import { useState, useCallback } from 'react';
export default function useSyncState() {
  const {
    0: autocompleteState,
    1: setAutocompleteState
  } = useState({});
  const resetState = () => {
    setAutocompleteState({
      activeItemId: null,
      collections: [],
      completion: null,
      context: {},
      isOpen: false,
      query: '',
      status: 'idle'
    });
  };
  const onStateChange = _ref => {
    let {
      state: newState
    } = _ref;
    setAutocompleteState(oldState => {
      const hasActiveItemId = newState.activeItemId !== null;
      const collectionEmpty = newState.collections.length === 0;
      return hasActiveItemId || collectionEmpty ? oldState : newState;
    });
  };
  return {
    autocompleteState,
    onStateChange: useCallback(onStateChange, []),
    resetState: useCallback(resetState, [])
  };
}